import {
  NOTIFY,
} from '../actions'

const initialState = {
  upgrade: false,
  message: null,
  info: false,
  error: false,
}

export default function app(state = initialState, action) {
  switch (action.type) {
    case NOTIFY:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
  